module.exports = __webpack_public_path__ + "static/img/zhongTopNew.b5aacaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhongBrand/zhongTopNew.png
// module id = SBx/
// module chunks = 0